import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of } from 'rxjs';
import { memo } from "../util/index.js";

function parseFlags(address, _ref) {
  var _ref2 = _slicedToArray(_ref, 5),
      electionsMembers = _ref2[0],
      councilMembers = _ref2[1],
      technicalCommitteeMembers = _ref2[2],
      societyMembers = _ref2[3],
      sudoKey = _ref2[4];

  var addrStr = address && address.toString();

  var isIncluded = function isIncluded(id) {
    return id.toString() === addrStr;
  };

  return {
    isCouncil: ((electionsMembers === null || electionsMembers === void 0 ? void 0 : electionsMembers.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          id = _ref4[0];

      return id;
    })) || councilMembers || []).some(isIncluded),
    isSociety: (societyMembers || []).some(isIncluded),
    isSudo: (sudoKey === null || sudoKey === void 0 ? void 0 : sudoKey.toString()) === addrStr,
    isTechCommittee: (technicalCommitteeMembers || []).some(isIncluded)
  };
}
/**
 * @name info
 * @description Returns account membership flags
 */


export function flags(instanceId, api) {
  return memo(instanceId, function (address) {
    var _api$query$council, _api$query$technicalC, _api$query$society, _api$query$sudo;

    var elections = api.query.phragmenElection || api.query.electionsPhragmen || api.query.elections;
    return combineLatest([address && elections !== null && elections !== void 0 && elections.members ? elections.members() : of(undefined), address && (_api$query$council = api.query.council) !== null && _api$query$council !== void 0 && _api$query$council.members ? api.query.council.members() : of([]), address && (_api$query$technicalC = api.query.technicalCommittee) !== null && _api$query$technicalC !== void 0 && _api$query$technicalC.members ? api.query.technicalCommittee.members() : of([]), address && (_api$query$society = api.query.society) !== null && _api$query$society !== void 0 && _api$query$society.members ? api.query.society.members() : of([]), address && (_api$query$sudo = api.query.sudo) !== null && _api$query$sudo !== void 0 && _api$query$sudo.key ? api.query.sudo.key() : of(undefined)]).pipe(map(function (r) {
      return parseFlags(address, r);
    }));
  });
}